import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 768;
const BREAKPOINT_2XL = 1536;

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < MOBILE_BREAKPOINT : false,
  );

  useEffect(() => {
    const media = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => setIsMobile(media.matches);
    media.addEventListener("change", onChange);
    setIsMobile(media.matches);
    return () => media.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}

export function useIs2XL(): boolean {
  const [is2XL, setIs2XL] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth >= BREAKPOINT_2XL : false,
  );

  useEffect(() => {
    const media = window.matchMedia(`(min-width: ${BREAKPOINT_2XL}px)`);
    const onChange = () => setIs2XL(media.matches);
    media.addEventListener("change", onChange);
    setIs2XL(media.matches);
    return () => media.removeEventListener("change", onChange);
  }, []);

  return is2XL;
}
